import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Chip, Paper, Stack, Typography } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';

type TileProps = {
  title: string;
  icon: ReactNode;
  to: string;
  description: string;
  id: string;
  beta?: boolean;
  deprecated?: boolean;
};

const Tile = ({
  id,
  title,
  icon,
  to,
  description,
  beta,
  deprecated,
}: TileProps) => {
  const intl = useIntl();
  return (
    <Box
      data-cy={`settings-tile-${id}`}
      component={RouterLink}
      to={to}
      sx={{
        flex: 1,
        '&:hover': {
          textDecoration: 'none ',
          '& h6': {
            color: 'inherit',
          },
        },
      }}
    >
      <Stack
        component={Paper}
        direction="column"
        px={4}
        py={3}
        gap={3}
        height={1}
        sx={{
          borderRadius: borderRadius('l'),
          transition: t => [t.transitions.create('background-color')],
          '&:hover': {
            textDecoration: 'none',
            backgroundColor: t => t.palette.action.selected,
          },
        }}
      >
        {icon}
        <Stack gap={1}>
          <Stack direction="row" gap={2} alignItems="center">
            <Typography variant="h5">{title}</Typography>
            {beta && (
              <Chip
                label={intl.formatMessage({ id: 'component.betaChip.label' })}
                color="warning"
                size="small"
              />
            )}
            {deprecated && (
              <Chip
                label={intl.formatMessage({
                  id: 'component.deprecatedChip.label',
                })}
                color="warning"
                size="small"
              />
            )}
          </Stack>
          <Typography color="text.secondary">{description}</Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default Tile;
